// extracted by mini-css-extract-plugin
export default {"container":"ON-z","topReviewHeading":"PN-z","criticalReview":"QN-z","favorableReview":"RN-z","vsSeparator":"SN-z"};